import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { getRequestId } from '@qxwz/http-client';
import { GraphQLError } from 'graphql';
import ErrorHandler from './error-handler';
import isomorphicUnfetch from 'isomorphic-unfetch';
import { AppName } from 'constant/app';
import { message } from '../utils/message';

const unfetch = isomorphicUnfetch.bind(window);

// @ts-ignore
function fetch(url: string, options?: isomorphicUnfetch.IsomorphicRequestInit) {
    const body = JSON.parse(options.body);
    return unfetch(`${url}/${body.operationName}`, {
        ...options,
        headers: {
            ...(options?.headers || {}),
            caller: AppName,
            'request-id': getRequestId(),
        },
    });
}

export function doCreateApolloClient(uri: string, errorHandler: ErrorHandler) {
    const authLink = setContext((request, { headers }) => ({
        headers: {
            ...headers,
            Cookie: document.cookie,
        },
    }));
    const httpLink = new HttpLink({
        uri,
        fetch,
        credentials: 'include',
    });
    const errorLink = onError(({ graphQLErrors, networkError }) => {
        if (networkError) {
            errorHandler.showNetworkErrors();
            return;
        }
        errorHandler.showGraphqlErrors(graphQLErrors as readonly GraphQLError[]);
    });
    const client = new ApolloClient({
        link: errorLink.concat(authLink.concat(httpLink)),
        cache: new InMemoryCache(),
        defaultOptions: {
            query: {
                errorPolicy: 'all',
                fetchPolicy: 'network-only',
            },
            watchQuery: {
                errorPolicy: 'all',
                fetchPolicy: 'cache-and-network',
            },
        },
    });

    return client;
}

export default function createApolloClient(errorHandler: ErrorHandler) {
    return doCreateApolloClient('/bffvenusv2/graphql', errorHandler);
}

export const gatewayClient = doCreateApolloClient(
    '/bffgatewaybiz/graphql',
    new ErrorHandler({
        toaster: message.error,
    }),
);
